import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { CardImg, Button, Nav, NavItem, NavLink, Spinner, ModalBody,
  CloseButton,
  Modal,
  FormGroup,
  FormFeedback, Alert, } from "reactstrap";
import Select from "react-select";

import { CustomizationSpinnerContainer } from "../common/style";
import {
  getSectionProducts,
  addOrderItemForTempUser,
  getPreviewSections,
  updateOrderItemForTempUser,
  clearSection,
  createProjectForPreAuthenticateUser,
  deleteSection,
  tableManager,
} from "../product/service";
import ConfirmationModal from "../project/ConfirmationModal";
import {
  ToggleContainer,
  ToggleCircle,
  RenderSectionCanvasElement,
} from "../project/style";
import {
  Card,
  CardGroup,
  CardImgContainer,
  CardProductName,
  OptionImage,
} from "../product/style";
import Cookies from "universal-cookie";
import { Input } from "./style";
import Link from "../common/Link";
import { fetchOtp, loginOtp, setAuthenticatedUser } from "../auth/service";
import { AuthButton, AuthInput } from "../auth/style";
import { useNavigate } from "react-router-dom";

const CATALOG_CATEGORY_DISPLAY_NAME = {
  wardrobe: "Wardrobe",
  floor_unit: "Floor Unit",
  wall_unit: "Wall Unit",
  loft: "Loft",
};

const PreviewPage = () => {
  const [catalogs, setCatalogs] = useState([]);
  const [sections, setSections] = useState();
  const [project, setProject] = useState([]);
  const [product, setProduct] = useState([]);
  const [activeSection, setActiveSection] = useState(null);
  const [sectionType, setSectionType] = useState("wardrobe");
  const [catalogsLoading, setCatalogsLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [notification, setNotification] = useState(null);
  const [errorMessage, setErrorMesaage] = useState("");
  const [roomId, setRoomId] = useState(null);
  const [projectUUID, setProjectUUID] = useState(null);
  const [renderingSize, setRenderingSize] = useState(20);
  const [showShutters, setShowShutters] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(null);
  const enableLogin =
    mobileNumber.length === 10 &&
    /^\d+$/.test(mobileNumber) &&
    (otp.length == 6);

  const [token, setToken] = useState(null);
  const [canvasSize, setCanvasSize] = useState(null);
  const cookies = new Cookies();
  const location = useLocation();
  const canvasRef = useRef(null);
  const [tempSelectedValues, setTempSelectedValues] = useState({});

  const [deletePackageConfirmationOpen, setDeletePackageConfirmationOpen] =
    useState(false);
  const toggleDeleteSectionConfirmation = () => {
    setDeletePackageConfirmationOpen(!deletePackageConfirmationOpen);
  };

  const [clearSectioneConfirmationOpen, setClearSectioneConfirmationOpen] =
    useState(false);
  const toggleClearSectionConfirmation = () => {
    setClearSectioneConfirmationOpen(!clearSectioneConfirmationOpen);
  };

  const [clearAndAddConfirmationOpen, setClearAndAddConfirmationOpen] =
    useState(false);
  const toggleClearAndAddConfirmation = () => {
    setClearAndAddConfirmationOpen(!clearAndAddConfirmationOpen);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    const existingProjectUUID = cookies.get("boxs_projectUUID");

    if (token) {
      if (!cookies.get("boxs_token")) {
        cookies.set("boxs_token", token, { maxAge: 60 * 60 * 24 * 60 });
      }

      if (!existingProjectUUID) {
        handleCreateProject(token);
      }
    }
  }, [location.search]);

  useEffect(() => {
    if (!cookies.get("boxs_projectUUID") && projectUUID) {
      cookies.set("boxs_projectUUID", projectUUID, {
        maxAge: token
          ? 60 * 60 * 24 * 60 // 2 months expiry
          : 60 * 60 * 24 * 7, // 7 days expiry
      });
    }
  }, [projectUUID]);

  useEffect(() => {
    if (cookies.get("boxs_projectUUID")) {
      setProjectUUID(cookies.get("boxs_projectUUID"));
    }
    if (cookies.get("boxs_token")) {
      setToken(cookies.get("boxs_token"));
    }
  }, []);

  useEffect(() => {
    setCatalogsLoading(true);
    getSectionProducts({ searchTerm: "", sectionType, token, sectionId: "" })
      .then((products) => {
        const categoryKey = Object.keys(products)[0];
        setCatalogs(products[categoryKey] || []);
        setActiveSection(findSection(sectionType));
      })
      .catch(({ error }) => {
        console.error("Error fetching products:", error);
      })
      .finally(() => setCatalogsLoading(false));
  }, [sectionType]);

  useEffect(() => {
    if (projectUUID) {
      fetchPreviewSections(projectUUID);
    }
  }, [projectUUID]);

  const handleAddProduct = (product, clearAndAdd = false) => {
    setSelectedProduct(product);
    setIsLoading(true);
    setProduct(product);

    addOrderItemForTempUser({
      product_id: product.id,
      projectUUID: projectUUID,
      roomId,
      clearAndAdd: clearAndAdd,
    })
      .then((response) => {
        if (response.project_uuid) {
          setProjectUUID(response.project_uuid);
        }

        fetchPreviewSections(roomId);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });

        // Regex to match error
        const sectionWidthExceededPattern =
          /The cabinets exceed the section width of (\d+)mm/;

        if (sectionWidthExceededPattern.test(error)) {
          setClearAndAddConfirmationOpen(true);
        } else {
          setClearAndAddConfirmationOpen(false);
          setErrorMesaage(error);
        }
      })
      .finally(() => setIsLoading(false));
  };

  const fetchPreviewSections = (roomId) => {
    setIsLoading(true);

    getPreviewSections({ projectUUID, roomId })
      .then((data) => {
        setSections(data.sections);
        setProject(data);
        const section = data.sections.find(
          (s) => s.section_type == sectionType
        );

        setActiveSection(section);
        setCanvasSize(null);
      })
      .catch((error) => {
        console.error("Failed to fetch sections", error);
      })
      .finally(() => setIsLoading(false));
  };

  const findSection = (sectionType) => {
    if (!sections) {
      return null;
    }

    return sections.find((section) => section.section_type === sectionType);
  };

  const handleUpdateProduct = (sectionId, updatedData) => {
    setIsLoading(true);
    setTempSelectedValues((prev) => ({
      ...prev,
      [sectionId]: {
        ...prev[sectionId],
        ...(updatedData.selected_values || {}),
      },
    }));

    const formattedData = { section: updatedData };

    updateOrderItemForTempUser({ sectionId, updatedData: formattedData })
      .then((response) => {
        if (response.project_uuid) {
          setProjectUUID(response.project_uuid);
        }

        const updatedSection = sections.find(
          (section) => section.id === sectionId
        );

        Object.assign(updatedSection, response);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
        setTempSelectedValues((prev) => ({
          ...prev,
          [sectionId]:
            sections.find((s) => s.id === sectionId)?.selected_values || {},
        }));
      })
      .finally(() => setIsLoading(false));
  };

  const handleCreateProject = (token) => {
    setIsLoading(true);

    createProjectForPreAuthenticateUser(token)
      .then((response) => {
        setProjectUUID(response.project_uuid);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally(() => setIsLoading(false));
  };

  const handleDeleteSection = () => {
    deleteSelectedSection();
    toggleDeleteSectionConfirmation();
  };

  const deleteSelectedSection = () => {
    deleteSection({ activeSectionId: activeSection.id })
      .then(() => {
        fetchPreviewSections(projectUUID);
      })
      .catch((error) => console.error("Error deleting section:", error));
  };
  const handleClearSection = () => {
    clearSelectedSection();
    toggleClearSectionConfirmation();
  };

  const clearSelectedSection = () => {
    clearSection(activeSection.id)
      .then(() => {
        const updatedSection = sections.find(
          (section) => section.id === activeSection.id
        );
        fetchPreviewSections(roomId);
      })
      .catch((error) => console.error("Error Clearing section:", error));
  };

  const ToggleSwitch = ({ isOn, toggle }) => {
    return (
      <ToggleContainer isOn={isOn} onClick={toggle}>
        <ToggleCircle isOn={isOn} />
      </ToggleContainer>
    );
  };

  function ModuleNode({ module }) {
    return (
      <RenderNode object={module} className={`module-node`}>
        {module.template && (
          <>
            <ComponentNode
              className="base-component"
              component={module.template.base_component}
            ></ComponentNode>
            <SpaceNode
              className="root-space"
              space={module.template.root_space}
              module={module}
            ></SpaceNode>
            {
              <div className="partitions">
                {module.template.partitions.map((partition, partitionIndex) => (
                  <PartitionNode
                    key={partitionIndex}
                    partition={partition}
                    module={module}
                  ></PartitionNode>
                ))}
              </div>
            }
            {!showShutters && (
              <div className="shutters">
                {module.template.shutters.map((shutter, shutterIndex) => (
                  <ShutterNode
                    className="shutter-node"
                    key={shutterIndex}
                    shutter={shutter}
                    module={module}
                  ></ShutterNode>
                ))}
              </div>
            )}
          </>
        )}
      </RenderNode>
    );
  }

  function PartitionNode({ partition, module }) {
    return (
      <ComponentNode
        component={partition.component}
        className={`partition-node`}
      />
    );
  }

  function ShutterNode({ shutter, module }) {
    if (shutter.is_removed && !module.has_profile_shutter) return;

    return <ComponentNode component={shutter.component} />;
  }

  function SpaceNode({ space, widthCount = -1, heightCount = -1, module }) {
    if (!space) return;
    if (space.width) widthCount++;
    if (space.height) heightCount++;

    return (
      <RenderNode object={space} className={`space-node`} key={space}>
        {space.children &&
          space.children.map((childSpace, spaceIndex) => (
            <SpaceNode
              key={spaceIndex}
              space={childSpace}
              widthCount={widthCount}
              heightCount={heightCount}
              module={module}
            ></SpaceNode>
          ))}
        {space.is_drawer && (
          <div className="h-100 pattern border border-black"></div>
        )}
      </RenderNode>
    );
  }

  function ComponentNode(props) {
    const component = props.component;
    const componentIndex = 0;

    return (
      <RenderNode
        object={component}
        className={`component-node`}
        key={componentIndex}
        {...props}
      >
        {component.panels.map((panel, panelIndex) => (
          <PanelNode
            key={panelIndex}
            panel={panel}
            componentType={component.type}
            componentIdentifier={component.identifier}
          ></PanelNode>
        ))}
      </RenderNode>
    );
  }

  function PanelNode({ panel, componentType, componentIdentifier }) {
    let style = {};

    let backgroundColor = componentType === "shutter" ? "#d9d9d9" : "none";

    let border = "1px solid black";
    let backgroundImage = componentType === "shutter" ? "none" : "";

    let backgroundRepeat = componentType === "shutter" ? "no-repeat" : "none";

    let backgroundSize = componentType === "shutter" ? "100% 100%" : "none";

    let boxShadow = "none";
    let zIndex = 0;

    if (panel.front_laminate) {
      if (panel.front_laminate.image_url) {
        backgroundImage = `url("${panel.front_laminate.image_url}")`;
        backgroundRepeat = "repeat";
        backgroundSize = `${
          panel.front_laminate.image_width / renderingSize
        }px ${panel.front_laminate.image_height / renderingSize}px`;
      } else if (panel.front_laminate.color_code) {
        backgroundColor = panel.front_laminate.color_code;
      }
    } else {
      // No laminate applied.
      backgroundColor: "#d9d9d9";
    }

    if (panel.orientation != "surface") {
      // Edge
      if (componentIdentifier === "removable_shelf") {
        border = "1px dashed black";
      } else {
        // Fixed partition - fill with black.
        backgroundColor = "black";
      }
    } else {
      if (panel.identifier == "backsheet") {
        zIndex = -1;
      }
    }

    style = {
      border: border,
      backgroundColor: backgroundColor,
      backgroundImage: backgroundImage,
      backgroundRepeat: backgroundRepeat,
      backgroundSize: backgroundSize,
      boxShadow: boxShadow,
      zIndex: zIndex,
    };

    return (
      <RenderNode
        object={panel}
        className="panel-node"
        style={style}
        key={panel.uniq_id}
      ></RenderNode>
    );
  }
  function RenderNode(props) {
    return (
      <RenderSectionCanvasElement
        renderingsize={renderingSize}
        // FIXME: Using zoom to calculate the outline slows the canvas.
        // zoom={zoom}
        className={`node`}
        {...props}
      >
        {props.children}
      </RenderSectionCanvasElement>
    );
  }
  const [timer, setTimer] = useState(0);

  const timeOutCallback = useCallback(() => setTimer(currTimer => currTimer - 1), []);
  const resetTimer = function () {
    if (!timer) {
      setTimer(30);
    }
  };
  useEffect(() => {
    timer > 0 && setTimeout(timeOutCallback, 1000);
  }, [timer, timeOutCallback]);

  function doLogin() {
    setIsLoading(true);

    loginOtp({ mobileNumber, otp })
      .then(({ token, user, plan_features }) => {
        setAuthenticatedUser({ token, user });
        setShowLoginModal(false);
      })
      .catch(({ error }) => {
        setError(error);
      })
      .finally((_) => setIsLoading(false));
  }

  function triggerGetOtp() {
    resetTimer();
    fetchOtp({ mobileNumber })
      .then(({ message }) => {
        alert("OTP has been sent to your mobile number");
      })
      .catch(({ error }) => {
        setError(error);
      })
  }

  const CustomSelect = ({ options, selectedValue, onChange }) => {
    return (
      <div style={{ position: "relative", width: "95%" }}>
        <Select
          className="compact-select"
          value={
            options.find((option) => option.identifier === selectedValue) ||
            null
          }
          menuPlacement="top"
          menuPosition="absolute"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          options={options.map((option, index) => {
            option.value = option.identifier;
            option.label = option.image ? (
              <div key={index}>
                {option.image && (
                  <OptionImage
                    key={index}
                    src={option.image}
                    alt={option.name}
                    className="me-2 border border-dark rounded-circle"
                  />
                )}
                {option.name}
              </div>
            ) : (
              option.name
            );
            option.key = index;

            return {
              value: option.identifier,
              label: option.name,
              ...option,
            };
          })}
          onChange={(selectedOption) => {
            onChange(selectedOption.identifier);
          }}
        />
      </div>
    );
  };

  const OptionPills = ({ options, selectedValue, onChange }) => {
    return (
      <div className="d-flex">
        {options.map((option) => (
          <div
            key={option.identifier}
            onClick={() => onChange(option.identifier)}
            className="p-1 me-2"
            style={{
              cursor: "pointer",
              fontSize: "10px",
              display: "flex",
              color: selectedValue === option.identifier ? "#fff" : "#000",
              backgroundColor:
                selectedValue === option.identifier ? "#2C92E6" : "none",
              border:
                selectedValue === option.identifier
                  ? "#999999"
                  : "1px solid #999999",
              borderRadius: "5px",
              alignItems: "center",
              padding: "2px 4px !important",
            }}
          >
            {option.name}
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    setCanvasSize(null);

    if (activeSection) {
      // Factor for fitting 2000mm height wardrobe in 240px height.
      const heightRenderFactor = 2000 / 240;

      // Factor for fitting 2450 width floor unit in 150px width.
      const widthRenderFactor = 2350 / 150;

      const minFactor = Math.max(heightRenderFactor, widthRenderFactor);

      setCanvasSize({
        height: activeSection.height / minFactor,
        width: activeSection.width / minFactor,
      });

      setRenderingSize(minFactor);
    }
  }, [activeSection]);

  return (
    <div>
      <div
        className="d-flex align-items-center w-100 ps-2 py-2"
        style={{ backgroundColor: "#283039", color: "white" }}
      >
        <i className="fa-solid fa-arrow-left fs-6 pointer" />
        <div className="ps-2 fs-5 fw-bold">Ordering</div>
        <div className="ps-2 " style={{ fontSize: "10px", color: "#AAAAAA" }}>
          Lite Version
        </div>
      </div>

      <Nav className="p-1 border-bottom">
        {Object.entries(CATALOG_CATEGORY_DISPLAY_NAME).map(([key, label]) => (
          <NavItem key={key}>
            <NavLink
              active={sectionType === key}
              onClick={() => setSectionType(key)}
              className="py-1 px-2 m-1"
              style={{
                cursor: "pointer",
                borderRadius: "5px",
                backgroundColor: sectionType === key ? "#2C92E6" : "#fff",
                color: sectionType === key ? "#fff" : "#999999",
                border: sectionType === key ? "none" : "1px solid #999999",
              }}
            >
              {label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      {catalogsLoading ? (
        <div className="d-flex justify-content-center p-5 fs-6">Loading...</div>
      ) : catalogs.length === 0 ? (
        <p className="text-center m-5">No products available</p>
      ) : (
        <CardGroup
          className="modules-listing row g-0 d-flex flex-wrap"
          style={{ paddingBottom: "40vh" }}
        >
          {catalogs.map((product, index) => (
            <div
              className="col-4 d-flex p-0 m-0"
              key={index}
              style={{ flexGrow: 1 }}
            >
              <Card
                className="module-card w-100 h-100 p-2 no-effect"
                style={{ margin: 0, borderRadius: 0 }}
              >
                <CardImgContainer>
                  <CardImg
                    className="object-fit-contain"
                    src={product.images[0]}
                    alt={product.name}
                  />
                </CardImgContainer>
                <div className="pt-2 d-flex flex-column">
                  <CardProductName>{product.name}</CardProductName>
                </div>
                <div
                  onClick={() => handleAddProduct(product)}
                  className="d-flex justify-content-center align-items-center text-center px-2 mt-1"
                  style={{
                    color: "#2C92E6",
                    width: "50%",
                    borderRadius: "5px",
                    border: "1px solid #2C92E6",
                    margin: "0 auto",
                  }}
                >
                  ADD
                </div>
              </Card>
            </div>
          ))}
        </CardGroup>
      )}

      <div className="overlay">
        {isLoading && (
          <div className="overlay-loader">
            <CustomizationSpinnerContainer>
              <Spinner />
            </CustomizationSpinnerContainer>
          </div>
        )}
        {sections && (
          <div className="d-flex flex-column w-100 h-100">
            <div className="content-container p-3">
              <div className="d-flex flex-column w-100 h-100">
                <div className="d-flex">
                  {activeSection && (
                    <div className="left-section d-flex flex-column align-items-start">
                      <div
                        className="mt-2 d-flex align-items-center fw-bold text-primary"
                        onClick={() => setShowShutters((prev) => !prev)}
                      >
                        <ToggleSwitch
                          isOn={showShutters}
                          toggle={(e) => {
                            e.stopPropagation();
                            setShowShutters((prev) => !prev);
                          }}
                        />
                        <div className="ms-2">Show Internals</div>
                      </div>
                      <div className="d-flex flex-grow-1 align-items-center">
                        <div
                          id="canvas"
                          ref={canvasRef}
                          className={"position-relative"}
                          style={{
                            height: canvasSize
                              ? `${canvasSize.height}px`
                              : "100%",
                            width: canvasSize
                              ? `${canvasSize.width}px`
                              : "100%",
                          }}
                        >
                          {activeSection.order_items?.map(
                            (order_item, moduleIndex) => (
                              <ModuleNode
                                key={moduleIndex}
                                module={order_item}
                              />
                            )
                          )}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between m-0 align-items-start">
                        <div className="d-flex flex-column">
                          <div
                            className="py-1 fs-6 fw-bold"
                            style={{ color: "#FF344C" }}
                          >
                            ₹{" "}
                            {activeSection?.sqft_price
                              ? `${activeSection.sqft_price.toLocaleString(
                                  "en-IN"
                                )} / sq.ft.`
                              : "N/A"}
                          </div>
                          <div>Delivery in 7 days.</div>
                          <div
                            className="text-secondary"
                            style={{ fontSize: "10px" }}
                          >
                            All hardwares and assembly fixtures included.
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="right-section ms-2">
                    <div
                      className="form-wrapper bg-white border"
                      style={{ padding: "12px" }}
                    >
                      <div className="mb-2">
                        <div className="mb-1 fw-bold">Carcass Material</div>
                        <OptionPills
                          options={project?.options?.carcass_material || []}
                          selectedValue={
                            tempSelectedValues[activeSection?.id]
                              ?.carcass_material ??
                            activeSection?.selected_values?.carcass_material ??
                            ""
                          }
                          onChange={(value) =>
                            handleUpdateProduct(activeSection?.id, {
                              selected_values: {
                                ...(activeSection?.selected_values || {}),
                                carcass_material: value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="mb-2">
                        <div className="mb-1 fw-bold">Shutter Material</div>
                        <OptionPills
                          options={project?.options?.shutter_material || []}
                          selectedValue={
                            tempSelectedValues[activeSection?.id]
                              ?.shutter_material ??
                            activeSection?.selected_values?.shutter_material ??
                            ""
                          }
                          onChange={(value) =>
                            handleUpdateProduct(activeSection?.id, {
                              selected_values: {
                                ...(activeSection?.selected_values || {}),
                                shutter_material: value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="mb-2">
                        <div className="mb-1 fw-bold">Shutter Lam</div>
                        <CustomSelect
                          options={project?.options?.shutter_color || []}
                          selectedValue={
                            tempSelectedValues[activeSection?.id]
                              ?.shutter_color ??
                            activeSection?.selected_values?.shutter_color ??
                            ""
                          }
                          onChange={(value) =>
                            handleUpdateProduct(activeSection?.id, {
                              selected_values: {
                                ...(activeSection?.selected_values || {}),
                                shutter_color: value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className="mb-2">
                        <div className="mb-1 fw-bold">Inner Lam</div>
                        <CustomSelect
                          options={project?.options?.internal_color || []}
                          selectedValue={
                            tempSelectedValues[activeSection?.id]
                              ?.internal_color ??
                            activeSection?.selected_values?.internal_color ??
                            ""
                          }
                          onChange={(value) =>
                            handleUpdateProduct(activeSection?.id, {
                              selected_values: {
                                ...(activeSection?.selected_values || {}),
                                internal_color: value,
                              },
                            })
                          }
                        />
                      </div>
                      <div>
                        <div className="mb-1 fw-bold">Hinges</div>
                        <CustomSelect
                          options={project?.options?.hinge || []}
                          selectedValue={
                            tempSelectedValues[activeSection?.id]?.hinge ??
                            activeSection?.selected_values?.hinge ??
                            ""
                          }
                          onChange={(value) =>
                            handleUpdateProduct(activeSection?.id, {
                              selected_values: {
                                ...(activeSection?.selected_values || {}),
                                hinge: value,
                              },
                            })
                          }
                        />
                      </div>
                    </div>
                    <div
                      className="text-secondary mt-1"
                      style={{ fontSize: "10px" }}
                    >
                      Login for more customizations.
                    </div>
                  </div>
                </div>

                <ConfirmationModal
                  isOpen={deletePackageConfirmationOpen}
                  toggle={toggleDeleteSectionConfirmation}
                  onConfirm={handleDeleteSection}
                  headingText="Delete Confirmation"
                  message="Are you sure you want to delete this section?"
                />
                <ConfirmationModal
                  isOpen={clearSectioneConfirmationOpen}
                  toggle={toggleClearSectionConfirmation}
                  onConfirm={handleClearSection}
                  headingText="Clear Confirmation"
                  message="Are you sure you want to clear this section?"
                />

                <div
                  className="text-center p-1"
                  style={{ color: "#999999", fontSize: "10px" }}
                >
                  <Link
                    className={"pe-1"}
                    onClick={() => setShowLoginModal(true)}
                  >
                  Login</Link>
                   for more options like G Profile handles, CNC, etc.
                </div>
                <ConfirmationModal
                  isOpen={clearAndAddConfirmationOpen}
                  toggle={toggleClearAndAddConfirmation}
                  onConfirm={() => handleAddProduct(product, true)}
                  message="Out of space. You need to clear to add the module"
                  headingText="Confirm Action"
                  confirmText="Clear and Add"
                  cancelText="Cancel"
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal isOpen={showLoginModal} toggle={() => setShowLoginModal(!showLoginModal)}>
        <ModalBody className="px-4">
          <div className="d-flex justify-content-end">
            <CloseButton onClick={() => setShowLoginModal(false)} className="fs-6" />
          </div>
          <div
            className="d-flex flex-column row-gap-2 align-items-center"
            style={{ marginTop: "-12px" }}
          >
            <h5 style={{ color: "#2C92E6" }} className="fw-bold">
              Please Login to view prices
            </h5>
            <FormGroup>
              <Input
                invalid={
                  mobileNumber.length > 0 &&
                  (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber))
                }
                type="text"
                value={mobileNumber}
                placeholder="Mobile Number"
                onChange={(ev) => setMobileNumber(ev.target.value)}
              />
              <FormFeedback>Please enter a valid Mobile number.</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Input
                type="number"
                value={otp}
                placeholder="OTP"
                onInput={(e) => {e.target.value.length >6 && (e.target.value = otp)}}
                onChange={(ev) => setOtp(ev.target.value)}
                invalid={
                  (otp.length > 6 || (otp.length >0 &&!/^\d+$/.test(otp)))
                }
              />
              <FormFeedback>Please enter a valid OTP</FormFeedback>
            </FormGroup>
            {error && (
              <Alert color="danger">
                {error} &nbsp;
                <Link
                  to="/catalogs"
                  fontWeight="500"
                  color="black"
                />
              </Alert>
            )}
            {
              (mobileNumber && mobileNumber.length == 10) &&
              (
                (timer === 0) ?
                  (
                    <Link onClick={() => triggerGetOtp()}>
                      Send OTP to: +91 <b>{mobileNumber}</b>
                    </Link>
                  ) :
                  (
                    <p>Resend OTP in ({timer})</p>
                  )
              )
            }

            <div className="d-grid gap-2 mt-1 mb-1 pt-3">
              <Button onClick={doLogin} disabled={!enableLogin || isLoading}>
                {isLoading ? (
                  <>
                    <Spinner size="sm">Loading...</Spinner> &nbsp;
                    <span>Loading...</span>
                  </>
                ) : (
                  "Login"
                )}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {isNotificationVisible && (
        <div className="notification">{notification?.message}</div>
      )}
    </div>
  );
};

export default PreviewPage;